import React from 'react'
import classNames from 'classnames'
import SvgChevronUp from '../../../atoms/Icons/Arrows/ChevronUp'
import SvgChevronDown from '../../../atoms/Icons/Arrows/ChevronDown'
import styles from './SortButton.module.scss'

interface ISortButtonProps {
  onClick: () => void
  order: false | 'asc' | 'desc'
}

const SortButton = ({ onClick, order }: ISortButtonProps) => {
  const classes = classNames(styles.root, {
    [styles.active]: order !== false,
  })

  return (
    <div className={classes}>
      <button onClick={onClick}>
        {(!order || order === 'asc') && <SvgChevronDown />}
        {order === 'desc' && <SvgChevronUp />}
      </button>
    </div>
  )
}

export default SortButton
